export default __webpack_public_path__ + "static/media/loadingMultipleProducts.ba52abf5.gif";